import {get} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//根据用户信息
export const getSeaIceList = p => get(proxyHeader + 'service/product-service/product-report/list', p);
export const getPathList = p => get(proxyHeader + 'service/dataprocess-service/algoResourceAddr/list', p);
export const getSatelliteList = p => get(proxyHeader + 'service/dataprocess-service/algoResourceAddr/satelliteList', p);